import React from 'react';
import { motion } from 'motion/react';
import styles from './Badge.module.css';
import { SPRING } from '../../utils/motion';

const VARIANTS = ['default', 'success', 'warning', 'error', 'pending', 'gold'];

export default function Badge({ children, variant = 'default', className = '' }) {
  const v = VARIANTS.includes(variant) ? variant : 'default';
  return (
    <motion.span
      className={`${styles.badge} ${styles[v]} ${className}`}
      initial={{ opacity: 0, scale: 0.85 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={SPRING.snappy}
    >
      {children}
    </motion.span>
  );
}
